import { render, staticRenderFns } from "./notificationrecord.vue?vue&type=template&id=7920ed90&scoped=true&"
import script from "./notificationrecord.vue?vue&type=script&lang=js&"
export * from "./notificationrecord.vue?vue&type=script&lang=js&"
import style0 from "./notificationrecord.vue?vue&type=style&index=0&id=7920ed90&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7920ed90",
  null
  
)

export default component.exports